const DEV_LIST = [
  'Nabendu.Karmakar.Contractor',
  'Shahbaz.Alam.Contractor',
  'Rithuraj.MG.Contractor',
  'Priyanath.Mukherjee.Contractor',
  'Rohan.Dharamshi.Contractor',
  'Nandini.Gottumukkala',
  'Rakesh.Kumar4.Contractor',
  'Dipti.Shirke.Contractor',
  'Ashish.Yadav.Contractor',
  'Rohit.Agarwal.Contractor',
  'Ninad.Dholakia.Contractor',
  'Himanshu.Tewari.Contractor',
  'Samidha.Singh.Contractor',
  'Madhu.suryawanshi.Contractor',
  'Bhargav.Upadhay.Contractor',
  'Preeti.Joshi',
  'Ramachandra.Behera.Contractor',
  'K.Deepak.Contractor',
  'Amisha.Sharma.Contractor',
  'venkatraman.ramaswamy.contractor',
  'Gopikrishna.M',
  'Advait.Ojale.Contractor',
  'Dave.Palmieri',
  '91120427',
  '91120428',
  '91120429',
  '91120430',
  '91112234',
  '91112236',
  'Andrew.Belcher',
  'Ashley.Barge',
  'Deepesh.Rai.Contractor',
  'Maaz.Hasan.Contractor',
  'Peter.Clay',
  'Sriram.Anandan.Contractor',
  'Trinadh.Amireddy.Contractor',
  'Vishal.Garg1.Contractor',
  'Debanjali.Dutta',
  'leonard.lopez'
];

/* Provided by Soniya on 06 Dec 2024 */
const ADMIN_LIST = [
  'lee.brady',
  'april.carr',
  'ryan.klaus',
  'arun.mulchandani',
  'Alberto.AguilarBaez',
  'Bhavani.Aravind',
  'Jason.Edmiston',
  'Liz.Kupillas',
  'lynnette.matthews',
  'revathy.padmanaban',
  'soniya.kotwani',
  'bhavika.shah',
  'arun.mulchandani',
  'jan.jeczmyk',
  'Jai.Dubey',
  'Josep.Carreras',
  'Sreedevi.Kaimal.Contractor',
  'Aaron.Mays'
];

export const getSanitizedMemberList = (fullList) => {
  let environmentPaths = ['dtv-tpo.mypepsico.com', 'dtv-tpo.preprod.mypepsico.com'];
  if (!environmentPaths?.includes(window.location.host)) {
    return fullList;
  }
  const mergedArray = [...DEV_LIST, ...ADMIN_LIST];
  const lowerCaseFilterList = mergedArray?.map((item) => {
    return item?.toLowerCase();
  });
  return fullList?.filter((item) => {
    if (typeof item?.userEmail === 'string' || typeof item?.UserEmail === 'string') {
      const formattedEmail = item?.UserEmail
        ? item?.UserEmail?.toLowerCase()?.replace('@pepsico.com', '')
        : item?.userEmail?.toLowerCase()?.replace('@pepsico.com', '');
      return !lowerCaseFilterList?.includes(formattedEmail);
    }
    return false;
  });
};
